import { render, staticRenderFns } from "./installGuide.vue?vue&type=template&id=b8825f12&scoped=true&"
import script from "./installGuide.vue?vue&type=script&lang=js&"
export * from "./installGuide.vue?vue&type=script&lang=js&"
import style0 from "./installGuide.vue?vue&type=style&index=0&id=b8825f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8825f12",
  null
  
)

export default component.exports